import { render, staticRenderFns } from "./DialogImportPermission.vue?vue&type=template&id=c64612dc&scoped=true&"
import script from "./DialogImportPermission.vue?vue&type=script&lang=ts&"
export * from "./DialogImportPermission.vue?vue&type=script&lang=ts&"
import style0 from "./DialogImportPermission.vue?vue&type=style&index=0&id=c64612dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64612dc",
  null
  
)

export default component.exports